import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TextSnippetIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "TextSnippet",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M17.62 2h10.77c.59 0 1.08.48 1.08 1.08s-.48 1.08-1.08 1.08H17.62c-.59 0-1.08-.48-1.08-1.08S17.02 2 17.62 2m0 6.46h10.77c.59 0 1.08.48 1.08 1.08s-.48 1.08-1.08 1.08H17.62c-.59 0-1.08-.48-1.08-1.08s.48-1.08 1.08-1.08m0 6.46h10.77c.59 0 1.08.48 1.08 1.08s-.48 1.08-1.08 1.08H17.62c-.59 0-1.08-.48-1.08-1.08s.48-1.08 1.08-1.08m-14 6.46h24.77c.59 0 1.08.48 1.08 1.08s-.48 1.08-1.08 1.08H3.62c-.59 0-1.08-.48-1.08-1.08s.48-1.08 1.08-1.08m0 6.46h24.77c.59 0 1.08.48 1.08 1.08S28.99 30 28.39 30H3.62c-.59 0-1.08-.48-1.08-1.08s.48-1.08 1.08-1.08M12.23 2H3.62c-.59 0-1.08.48-1.08 1.08 0 .59.48 1.08 1.08 1.08h3.23v11.85c0 .59.48 1.08 1.08 1.08s1.08-.48 1.08-1.08V4.15h3.23c.59 0 1.08-.48 1.08-1.08s-.48-1.08-1.08-1.08Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M11.57 6.14H3a1.14 1.14 0 1 1 0-2.28h8.57a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.29 17.57c-.63 0-1.14-.51-1.14-1.14V5.48a1.14 1.14 0 1 1 2.28 0v10.95c0 .63-.51 1.14-1.14 1.14M28.14 17.57H17.86a1.14 1.14 0 1 1 0-2.28h10.28a1.14 1.14 0 1 1 0 2.28M28.14 11.86H17.86a1.14 1.14 0 1 1 0-2.28h10.28a1.14 1.14 0 1 1 0 2.28M28.14 6.14H17.86a1.14 1.14 0 1 1 0-2.28h10.28a1.14 1.14 0 1 1 0 2.28M28.14 23.29H3a1.14 1.14 0 1 1 0-2.28h25.14a1.14 1.14 0 1 1 0 2.28M28.14 29H3a1.14 1.14 0 1 1 0-2.28h25.14a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};
TextSnippetIcon.displayName = 'TextSnippetIcon';